"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprintApi = exports.SprintApiFactory = exports.SprintApiFp = exports.SprintApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SprintApi - axios parameter creator
 * @export
 */
exports.SprintApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Finalize sprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeSprint: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('finalizeSprint', 'id', id);
            const localVarPath = `/sprint/{id}/finalize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sprint by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprintById: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getSprintById', 'id', id);
            const localVarPath = `/sprint/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SprintApi - functional programming interface
 * @export
 */
exports.SprintApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SprintApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Finalize sprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeSprint(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finalizeSprint(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sprint by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprintById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSprintById(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SprintApi - factory interface
 * @export
 */
exports.SprintApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SprintApiFp(configuration);
    return {
        /**
         *
         * @summary Finalize sprint
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeSprint(id, options) {
            return localVarFp.finalizeSprint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sprint by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprintById(id, options) {
            return localVarFp.getSprintById(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SprintApi - object-oriented interface
 * @export
 * @class SprintApi
 * @extends {BaseAPI}
 */
class SprintApi extends base_1.BaseAPI {
    /**
     *
     * @summary Finalize sprint
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprintApi
     */
    finalizeSprint(id, options) {
        return exports.SprintApiFp(this.configuration).finalizeSprint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sprint by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprintApi
     */
    getSprintById(id, options) {
        return exports.SprintApiFp(this.configuration).getSprintById(id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SprintApi = SprintApi;
